export enum TriState {
  True = 'true',
  False = 'false',
  Mixed = 'mixed',
}
